export default "__VITE_ASSET__DMY3cHmI__"